'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

// dispatched by the monitor
var EFFECT_TRIGGERED = exports.EFFECT_TRIGGERED = 'EFFECT_TRIGGERED';
var EFFECT_RESOLVED = exports.EFFECT_RESOLVED = 'EFFECT_RESOLVED';
var EFFECT_REJECTED = exports.EFFECT_REJECTED = 'EFFECT_REJECTED';
var EFFECT_CANCELLED = exports.EFFECT_CANCELLED = 'EFFECT_CANCELLED';
var ACTION_DISPATCHED = exports.ACTION_DISPATCHED = 'ACTION_DISPATCHED';

// dispatched by UI
var SET_SHARED_REF = exports.SET_SHARED_REF = 'SET_SHARED_REF';

// status of an Effect
var STATUS_PENDING = exports.STATUS_PENDING = 'STATUS_PENDING';
var STATUS_RESOLVED = exports.STATUS_RESOLVED = 'STATUS_RESOLVED';
var STATUS_REJECTED = exports.STATUS_REJECTED = 'STATUS_REJECTED';
var STATUS_CANCELLED = exports.STATUS_CANCELLED = 'STATUS_CANCELLED';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-devtools/lib/store/constants.js
// module id = 14
// module chunks = 0